// extracted by mini-css-extract-plugin
export default {"page":"buyers_page__wbVbc","buyers__container":"buyers_buyers__container__Rdbo3","buyers__content":"buyers_buyers__content__ROKM3"};